import createAxiosInstance from './axiosConfig';
import { Alcada } from '../shared/model/alcada';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/alcadaController');

export default class AlcadaService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarTodasAlcadas(currentPage: number, max: number) {
    return await this.axios.get(`/listarTodasAlcadas?page=${currentPage}&max=${max}`);
  };

  async listarAlcadaPorId(id: string) {
    return await this.axios.get(`/listarAlcadaPorId?id=${id}`);
  };

  async incluirAlterarAlcada(dto: Alcada) {
    return await this.axios.post(`/incluirAlterarAlcada`, dto);
  };

  async excluirAlcada(id: number | string) {
    return await this.axios.get(`/excluirAlcada?id=${id}`);
  };

  async listarAlcadaPorTipoAcesso(tipoAcesso: string) {
    return await this.axios.get(`/listarAlcadaPorTipoAcesso?tipoAcesso=${tipoAcesso}`);
  };


}